import { defaultReducerMapping } from "../lib/redux"
import deepFreeze from "deep-freeze"

var { APP_SIGN_OUT } = require("../actions/app")

var { ACTIVITY_KEY_NOTIFICATIONS } = require("../actions/activity")

var {
  NOTIFICATIONS_REFRESH,
  NOTIFICATIONS_FETCH_PAGE,
  NOTIFICATIONS_FETCH_PAGE_COMPLETE,
  NOTIFICATIONS_FETCH_PAGE_FAILED,
} = require("../actions/notifications")

var { APP_FETCH_CURRENT_USER_COMPLETE } = require("../actions/app")

var { PUSH_RECEIVE_NOTIFICATION } = require("../actions/push")

var initialState = deepFreeze({
  loaded: false,
  page: 1,
  refreshing: false,
  loadingPage: false,
  noMoreData: false,
  notificationIds: [],
})

//Just return the new/change parts of the state
var map = {}

map[PUSH_RECEIVE_NOTIFICATION] = (state, action) => {
  if (
    action.selectedTab === "activity" &&
    action.selectedActivityTab === ACTIVITY_KEY_NOTIFICATIONS
  ) {
    return initialState
  }
}

map[APP_FETCH_CURRENT_USER_COMPLETE] = (state, action) => {
  if (action.user.unread_notifications_count > 0) {
    return initialState
  }
}

map[NOTIFICATIONS_REFRESH] = (state, action) => {
  return {
    refreshing: true,
    page: 1,
  }
}

map[NOTIFICATIONS_FETCH_PAGE] = (state, action) => {
  return {
    loaded: true,
    loadingPage: true,
  }
}

map[NOTIFICATIONS_FETCH_PAGE_COMPLETE] = (state, action) => {
  // Seems action.notifications comes back undefined if no notifications present:
  var notifications = action.notifications || []

  var newNotificationIds = notifications.map(n => n.id)

  return {
    loaded: true,
    loadingPage: false,
    refreshing: false,
    page: state.page + 1,
    noMoreData: notifications.length === 0,
    notificationIds:
      state.refreshing || action.page === 1
        ? newNotificationIds
        : state.notificationIds.concat(newNotificationIds),
  }
}

map[NOTIFICATIONS_FETCH_PAGE_FAILED] = (state, action) => {
  return {
    loaded: true,
    loadingPage: false,
    refreshing: false,
  }
}

map[APP_SIGN_OUT] = (state, action) => {
  return initialState
}

export default defaultReducerMapping(initialState, map)
